"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _inputPresentation = _interopRequireWildcard(require("./input-presentation.style"));

var _extractProps = _interopRequireDefault(require("../../utils/helpers/extract-props"));

var _inputBehaviour = require("../input-behaviour");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const InputPresentation = ({
  children,
  positionedChildren,
  inputWidth,
  ...rest
}) => {
  const {
    hasFocus,
    onMouseDown,
    onMouseEnter,
    onMouseLeave
  } = (0, _react.useContext)(_inputBehaviour.InputContext);
  const {
    onMouseEnter: onGroupMouseEnter,
    onMouseLeave: onGroupMouseLeave
  } = (0, _react.useContext)(_inputBehaviour.InputGroupContext);
  const styleProps = (0, _extractProps.default)(rest, _inputPresentation.default);

  const handleMouseEnter = e => {
    if (onMouseEnter) onMouseEnter(e);
    if (onGroupMouseEnter) onGroupMouseEnter(e);
  };

  const handleMouseLeave = e => {
    if (onMouseLeave) onMouseLeave(e);
    if (onGroupMouseLeave) onGroupMouseLeave(e);
  };

  return /*#__PURE__*/_react.default.createElement(_inputPresentation.StyledInputPresentationContainer, {
    inputWidth: inputWidth
  }, positionedChildren, /*#__PURE__*/_react.default.createElement(_inputPresentation.default, _extends({
    hasFocus: hasFocus,
    role: "presentation",
    onMouseDown: onMouseDown,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, styleProps), children));
};

InputPresentation.propTypes = {
  children: _propTypes.default.node,
  align: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  hasFocus: _propTypes.default.bool,
  inputWidth: _propTypes.default.number,
  readOnly: _propTypes.default.bool,
  positionedChildren: _propTypes.default.node,
  size: _propTypes.default.oneOf(["small", "medium", "large"]),
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  warning: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  info: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
};
var _default = InputPresentation;
exports.default = _default;